// extracted by mini-css-extract-plugin
export var button = "_6z-0";
export var icon = "_6z-1";